const InputValidator = (inputType, value) => {
  let re = ''
  switch (inputType) {
    case 'email':
      re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      return re.test(value)

    case 'tel':
      re = /^(\+{0,1}\d{11,13})$/
      return re.test(value)

    case 'password':
      return (value !== '' && value.length > 5)

    default:
      return (value !== '')
  }
}

export const ErrorMessages = (inputType, value) => {
  if (value === '') {
    return 'Value can not be empty'
  }
  switch (inputType) {
    case 'email':
      if (!value.includes('@')) {
        return 'Email must contain @'
      }
      value = value.split('@')
      if (value[2] === '') {
        return 'Please complete email after @'
      }
      return 'Invalid email'

    case 'tel':
      if (value.length < 11) {
        return 'Phone number is too short'
      } else if (value.length > 13) {
        return 'Phone number is too long'
      }
      return 'Invalid phone number'

    case 'password':
      return 'Password must be longer than 5 characters'
    default:
      return (value !== '')
  }
}

export default InputValidator



// WEBPACK FOOTER //
// ./src/utils/validators.js